import {_} from 'lodash';
import {IOverride} from '../../../index';
import {global, lm} from '../../../appContext';
import {nsFa} from '../../fa/fn';
import {nsGroupMemberOverride} from './nsGroupMemberOverride';
import filterUserMembershipOverrides = nsGroupMemberOverride.filterUserMembershipOverrides;
import isMembershipOverrideDeleted = nsGroupMemberOverride.isMembershipOverrideDeleted;
import i = nsFa.i;

export namespace nsGroupMembers {

    /** User ids with an active group membership override (not selectable in add-members search). */
    export function collectOverrideTargetUserIds(overrides: IOverride[]): number[] {
        return _.uniq(
            filterUserMembershipOverrides(overrides)
                .filter(o => !isMembershipOverrideDeleted(o))
                .map(o => o.targetobjectid)
                .filter((id): id is number => id != null),
        );
    }

    /**
     * One-time education before creating a membership override (add wizard / first remove).
     * Honours `hide.automatic.override.warning`. Not used for cancel/remove/restore of existing overrides.
     */
    export function showManualMembershipEducationConfirm(onConfirm: () => void): void {
        const hideAutomaticOverrideWarning = global.storeObservable('hide.automatic.override.warning');

        if (hideAutomaticOverrideWarning()) {
            onConfirm();
            return;
        }

        global.dialogManager.addConfirm({
            content: `<p>${lm.t('warning: overriding group membership')}</p>
<p>${lm.t('are you sure you want to continue')}</p>
<p>
<!-- ko _component: {
    name: 'component/toggle/checkbox',
    params: {
        toggle: $root.global.storeObservable('hide.automatic.override.warning'),
        label: 'do not show this again',
    }
} --><!-- /ko -->
</p>`,
            title: `${i('fa-exclamation-triangle')} ((group membership override))`,
            buttons: {
                confirm: {
                    onClick: onConfirm,
                    label: 'continue',
                },
                cancel: {
                    label: 'cancel',
                },
            },
        });
    }

}
